import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="About" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500">
        Thanks to  {' '}
        <a
          href="https://github.com/hannahcode/wordle"
          className="underline font-bold"
        >hannahcode</a> for the open source version of the game Wordle. Check out the code {' '}
        <a
          href="https://github.com/hannahcode/wordle"
          className="underline font-bold"
        >
          here
        </a>{' '}
        and{' '} play the original {' '}
        <a
          href="https://www.powerlanguage.co.uk/wordle/"
          className="underline font-bold"
        >
          here
        </a>. Send me an email if you have five-letter word suggestions. Cheers!
      </p>
    </BaseModal>
  )
}
